/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Describes a role that an employee can fulfill within a company
 * @export
 * @interface JobRole
 */
export interface JobRole {
    /**
     * 
     * @type {number}
     * @memberof JobRole
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof JobRole
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof JobRole
     */
    name: string;
    /**
     * The status of the entity.
     * @type {string}
     * @memberof JobRole
     */
    status: JobRoleStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JobRole
     */
    colour: string;
    /**
     * 
     * @type {number}
     * @memberof JobRole
     */
    position: number;
    /**
     * 
     * @type {Date}
     * @memberof JobRole
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof JobRole
     */
    updatedAt: Date | null;
}

/**
* @export
* @enum {string}
*/
export enum JobRoleStatusEnum {
    Active = 'Active',
    Archived = 'Archived',
    Deleted = 'Deleted'
}


/**
 * Check if a given object implements the JobRole interface.
 */
export function instanceOfJobRole(value: object): value is JobRole {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('colour' in value) || value['colour'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function JobRoleFromJSON(json: any): JobRole {
    return JobRoleFromJSONTyped(json, false);
}

export function JobRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobRole {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'name': json['name'],
        'status': json['status'],
        'colour': json['colour'],
        'position': json['position'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
    };
}

  export function JobRoleToJSON(json: any): JobRole {
      return JobRoleToJSONTyped(json, false);
  }

  export function JobRoleToJSONTyped(value?: JobRole | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'name': value['name'],
        'status': value['status'],
        'colour': value['colour'],
        'position': value['position'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': (value['updatedAt'] == null ? null : (value['updatedAt'] as any).toISOString()),
    };
}

